module.exports = __webpack_public_path__ + "2b2d0b64508341d04ef25cc593abec2e.pdf";